<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Pawstagram</ion-title>
    <ion-buttons slot="primary">
      <ion-button [routerLink]="['/chats']"><ion-icon name="chatbox" slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/notifications']"><ion-icon name="notifications"
          slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/account']"><ion-icon name="menu-outline" slot="icon-only"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)" color="primary">
    <ion-refresher-content pullingText="Pull to refresh" refreshingSpinner="circular" refreshingText="Refreshing...">
    </ion-refresher-content>
  </ion-refresher>
  <div class="ion-padding ion-text-center" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div *ngIf="!isLoading">
    <div class="ion-padding ion-text-center" *ngIf="posts.length ===0">
      <ion-text color="darkmimbo">There are no posts yet. You can start by adding your own.</ion-text>
    </div>

    <div *ngIf="posts.length >0">
      <app-post-card *ngFor="let post of posts" [post]="post" [userId]="userId" [posts]="posts"></app-post-card>
    </div>
    <ion-fab slot="fixed" horizontal="end" vertical="bottom">
      <ion-fab-button>
        <ion-icon name="add"></ion-icon>
      </ion-fab-button>
      <ion-fab-list side="top">
        <ion-fab-button color="primary" (click)="onPickImageFromCamera('Gallery')">
          <ion-icon name="image-outline" style="font-size: 24px"></ion-icon>
        </ion-fab-button>
        <ion-fab-button color="primary" (click)="onPickImageFromCamera('Camera')">
          <ion-icon name="camera-outline" style="font-size: 24px"></ion-icon>
        </ion-fab-button>
      </ion-fab-list>
    </ion-fab>
  </div>
  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)" *ngIf="!isLoading && HasMoreData">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>